module.exports = __webpack_public_path__ + "static/media/Stroke10.85ba7468.svg";